<div>{{'history.event.node-links-changed'|translate}}</div>
<small>&#x2022; {{'history.event.node-links-changed.detail'|translate:linkTranslate()}}</small>
